export default __webpack_public_path__ + "static/media/flag-checked-circle-tc.0eb59af2.svg";